// components/CaloriesBarChart.js
import React from "react"
import ReactApexChart from "react-apexcharts"
import moment from "moment"

const CaloriesBarChart = ({ data }) => {
  // Extract dates and calories
  const categories = data?.map(item => moment(item.date).format("DD-MM"))

  const seriesData = data?.map(item => Number(item.calories).toFixed(2))

  const options = {
    chart: {
      type: "bar",
      zoom: { enabled: true },
      toolbar: { show: true },
    },
    plotOptions: {
      bar: {
        horizontal: false, // vertical bars
        columnWidth: "45%",
        borderRadius: 4,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
      labels: {
        rotate: -45,
        rotateAlways: true,
        hideOverlappingLabels: true,
        trim: false,
        maxHeight: 120,
      },
      title: {
        text: "Activity Dates",
        offsetY: 130,
      },
      range: 14,
    },

    yaxis: {
      title: { text: "Calories Burned (kcal)" },
    },
    colors: ["#2E93fA"],
    tooltip: {
      y: {
        formatter: val => `${val.toFixed(1)} kcal`,
      },
    },
  }

  const series = [
    {
      name: "Calories Burned",
      data: seriesData || [],
    },
  ]

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height={250}
      width="100%"
    />
  )
}

export default CaloriesBarChart
